import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormControl } from '@angular/forms'
import { Destroyable, untilDestroy } from '@tokeet/tv3-platform'

let id = 1

@Component({
  selector: 'app-form-switch',
  templateUrl: './form-switch.component.html',
  styleUrls: ['./form-switch.component.scss'],
})
export class FormSwitchComponent extends Destroyable implements OnInit {
  @Input() ctrl: FormControl = new FormControl()
  @Input() label: string
  @Input() labelReverse = false

  @Input() set checked(value: boolean) {
    this.ctrl?.setValue(value, { emitEvent: false })
  }

  @Input() set disabled(value: boolean) {
    if (value) {
      this.ctrl?.disable({ emitEvent: false })
    } else {
      this.ctrl?.enable({ emitEvent: false })
    }
  }

  @Output() valueChange = new EventEmitter<boolean>()

  id = id++

  constructor() {
    super()
  }

  ngOnInit(): void {
    this.ctrl?.valueChanges.pipe(untilDestroy(this)).subscribe(() => {
      this.valueChange.emit(this.ctrl.value)
    })
  }
}
